import type { TemplatesType } from '@rjsf/utils';
import FieldTemplate from './field-template';
import ObjectFieldTemplate from './object-field-template';
import SubmitButtonTemplate from './submit-button-template';

interface ITemplates extends Partial<Omit<TemplatesType, 'ButtonTemplates'>> {
  ButtonTemplates: Partial<TemplatesType['ButtonTemplates']>;
}

const templates: ITemplates = {
  FieldTemplate,
  ObjectFieldTemplate,
  ButtonTemplates: {
    SubmitButton: SubmitButtonTemplate,
  },
};

export default templates;
